module.exports = __webpack_public_path__ + "img/img_icon_02.2daee399.png";